const updateCompaniesStr = {
  toastr: 'Updated company',
  toastr1: ' has been updated successfully',
  toastrError: 'Company already registered',
  toastrError1: 'Enter this CNPJ or Name already registered'
};

export default updateCompaniesStr;
